"use client";

import { useLingui } from "@lingui/react/macro";
import { WysiwygView } from "@offstreetparking/portal-flow/components/forms/Wysiwyg/WysiwygView";
import { AuthCardLayout } from "~/components/auth/AuthCardLayout";
import { useCompany } from "~/components/providers/CompanyProvider";
import { LoginFormContent, type LoginFormProps } from "./LoginFormContent";

export const LoginForm = (props: LoginFormProps) => {
	const { t } = useLingui();
	const { company } = useCompany();
	return (
		<AuthCardLayout title={t`Sign In`} description={company?.loginInstructions}>
			<LoginFormContent {...props} />
			{company?.additionalLoginInfo && (
				<div className="rounded-lg border border-neutral-faded bg-white p-4">
					<WysiwygView content={company.additionalLoginInfo} />
				</div>
			)}
		</AuthCardLayout>
	);
};
